// Modal "Cambiar lote del próximo escaneo".
//
// Caso de uso: el operario está escaneando producto A con lote L-A1; se
// acaba el pallet/envase de L-A1 y abre el siguiente que es L-A2.
// Toca la línea del producto en el listado del pedido → este modal →
// escribe el lote nuevo → siguiente lectura crea una línea separada
// con el lote nuevo (la línea con L-A1 se queda intacta).
//
// Resuelve con `string | null | undefined`:
//   - string → nuevo lote a memorizar
//   - null   → quitar el lote memorizado (el próximo scan pedirá lote desde cero)
//   - undefined → cancelar (no cambia nada)

import { icon } from './icons.js';

const escapeHtml = (s) => String(s ?? '').replace(/[&<>"']/g,
  c => ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c]));

let _host = null;
function _close() { if (_host) { _host.remove(); _host = null; } }

/**
 * @param {object} opts
 * @param {{producto_id, descripcion, barcode}} opts.linea — línea del pedido.
 * @param {string|null} opts.loteActual — lote memorizado ahora (o null si no hay).
 */
export function openCambiarLoteModal({ linea, loteActual }) {
  return new Promise((resolve) => {
    _host = document.createElement('div');
    document.body.appendChild(_host);

    const tieneLote = !!loteActual;
    const ref = escapeHtml(linea.barcode || `#${linea.producto_id}`);
    const desc = escapeHtml(linea.descripcion);

    _host.innerHTML = `
      <div class="scrim fade-in"><div class="modal">
        <h2>${icon('tag', { size: 22 })} Lote del próximo escaneo</h2>
        <p>${desc} <span class="hint">(${ref})</span></p>

        ${tieneLote ? `
          <div class="lote-found">
            <div class="ico">${icon('check', { size: 22 })}</div>
            <div class="info">
              <div class="label">Lote actual memorizado</div>
              <div class="value">${escapeHtml(loteActual)}</div>
            </div>
          </div>
          <p class="hint">Las próximas lecturas usarán el nuevo lote. Las unidades ya escaneadas con el lote anterior se quedan como están.</p>
        ` : `
          <div class="lote-missing">
            <span style="display:inline-flex;">${icon('alert-triangle', { size: 18 })}</span>
            <span>No hay lote memorizado para este producto en esta caja todavía.</span>
          </div>
        `}

        <div class="field">
          <label for="cl-input">Nuevo lote</label>
          <input id="cl-input" inputmode="text" autocomplete="off"
                 placeholder="Ej: L-2026-0142" value="${escapeHtml(loteActual || '')}" />
        </div>

        <div class="actions">
          <button class="btn --ghost" id="cl-cancel">Cancelar</button>
          <button class="btn --primary" id="cl-save">Guardar</button>
        </div>
      </div></div>`;

    const input = _host.querySelector('#cl-input');
    setTimeout(() => input.focus(), 50);
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') _host.querySelector('#cl-save').click();
    });

    _host.querySelector('#cl-cancel').addEventListener('click', () => { _close(); resolve(undefined); });
    _host.querySelector('#cl-save').addEventListener('click', () => {
      const v = input.value.trim();
      _close();
      resolve(v.length === 0 ? null : v);
    });
  });
}
